// Utility functions for recordings

import { guardedLocalStorage } from './fnStorage';

interface Recording {
    recordingId: string;
    listingId: string;
}

function getRecordings(): Recording[] {
    const recordingsData = guardedLocalStorage.getItem('recordings');
    return recordingsData ? JSON.parse(recordingsData) : [];
}

function findRecording(key: 'recordingId' | 'listingId', value: string): Recording | undefined {
    return getRecordings().find((recording) => recording[key] === value);
}

export function getRecordingIdFromListingId(listingId: string): string | undefined {
    return findRecording('listingId', listingId)?.recordingId;
}

export function getListingIdFromRecordingId(recordingId: string, recordings: any[]): string | undefined {
    const recording = recordings?.find((rec) => rec.id === recordingId);
    return recording?.listing?.id;
}
